import { render } from "./EditarInformesView.vue?vue&type=template&id=2301542d&scoped=true"
import script from "./EditarInformesView.vue?vue&type=script&lang=js"
export * from "./EditarInformesView.vue?vue&type=script&lang=js"

import "./EditarInformesView.vue?vue&type=style&index=0&id=2301542d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pablo Sastre\\OneDrive\\Escritorio\\BAIPManagerTestv2\\BaipMarket.Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2301542d"]])

export default __exports__